import { QueryClient } from '@tanstack/react-query';
import { ApiRequestError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (count, err) => {
        if (err instanceof ApiRequestError && err.status && err.status < 500) return false;
        return count < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});
